import { render, staticRenderFns } from "./FilterHeader.vue?vue&type=template&id=58824b50&scoped=true&"
import script from "./FilterHeader.vue?vue&type=script&lang=js&"
export * from "./FilterHeader.vue?vue&type=script&lang=js&"
import style0 from "./FilterHeader.vue?vue&type=style&index=0&id=58824b50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58824b50",
  null
  
)

export default component.exports